export const km = {
    LEFT: 'ឆ្វេង៖ផ្លាស់ប្តូរទៅថ្ងៃមុន។',
    RIGHT: 'ស្តាំ៖ផ្លាស់ទីទៅនៅថ្ងៃបន្ទាប់។',
    DOWN: 'ចុះក្រោម៖ផ្លាស់ទីទៅដេកបន្ទាប់។',
    UP: 'ឡើង៖ផ្លាស់ទីទៅមុជួរដេក។',
    PGUP: 'PgUp៖ផ្លាស់ទីកាលពីខែមុន។ ',
    PGDOWN: 'PgDown៖ផ្លាស់ប្តូរទៅនៅខែក្រោយ។ ',
    HOME: 'ទំព័រ៖ផ្លាស់ទីកាលពីឆ្នាំមុន។ ',
    END: 'បញ្ចប់៖ផ្លាស់ប្តូរទៅឆ្នាំក្រោយ។ ',
    ESC: 'គេ/នៅថ្ងៃ/បិទ៖បិទប្រតិទិន។ ',
    TITLE: 'ក្តារចុចក្ដីណែនាំ'
};
